/**
 * WebserviceIntegracao
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {WebserviceIntegracaoCollection} from '@/model/collection/WebserviceIntegracaoCollection'

/* TODO: review generated class */
export class WebserviceIntegracao extends Resource {
  idWebserviceFk: number | null = null
  path: string | null = null

  get $id() {
    /* TODO: define the ID */
    return 0
  }
  set $id(val) {
    /* TODO: define the ID */
  }

  /**
   * Gets a instance of a given ID of WebserviceIntegracao
   */
  async getWebserviceIntegracao(id: number) {
    return await Request.get(`/admin/webservice-integracao/${id}`)
      .name('getWebserviceIntegracao')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of WebserviceIntegracao
   */
  static async listWebserviceIntegracao(params: any) {
    return await Request.get(`/admin/webservice-integracao`, {params})
      .name('listWebserviceIntegracao')
      .as(WebserviceIntegracaoCollection)
      .getData()
  }

  /**
   * Persists a new instance of WebserviceIntegracao. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistWebserviceIntegracao() {
    return await Request.post(`/admin/webservice-integracao`, this)
      .name('persistWebserviceIntegracao')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of WebserviceIntegracao to use it in a CSV file
   */
  static async listCsvWebserviceIntegracao(params: any) {
    return await Request.get(`/admin/webservice-integracao/csv`, {params})
      .name('listCsvWebserviceIntegracao')
      .as(WebserviceIntegracaoCollection)
      .getData()
  }
}
